import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.m.scss';

import { handleErrorBase } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';

import Footer from '../../../../../components/Accordion/Footer';
import ProfessionalInfo from '../../../EditAccount/ProfessionalInfo';

const propTypes = {
  areasOfExpertise: PropTypes.array,
  workAreas: PropTypes.array,
  updateRegistration: PropTypes.func,
  setStep: PropTypes.func,
  step: PropTypes.number,
  updateUser: PropTypes.func,
};

const ProfessionalInfoStep = ({
  areasOfExpertise,
  workAreas,
  registration,
  step,
  setStep,
  updateRegistration,
  updateUser,
  name,
}) => {
  return (
    <ProfessionalInfo
      hideAFCPEPreferences
      areasOfExpertise={areasOfExpertise}
      workAreas={workAreas}
      user={registration.user}
      headerClass={styles.stepHeader}
      FooterComponent={Footer}
      footerProps={{ padded: true, step }}
      updateUser={updateUser}
      afterUpdate={() =>
        apiUpdateRegistration(registration.id, { stepName: name })
          .then(({ data }) => updateRegistration(data))
          .then(() => setStep(step + 1))
          .catch((err) => handleErrorBase('There was an error'))
      }
    />
  );
};

ProfessionalInfoStep.propTypes = propTypes;

export default ProfessionalInfoStep;
